<template>
  <div id="download">
    <NavigationBar />

    <div class="uk-section uk-section-muted" v-if="!loading">
      <div class="uk-container">
        <h2 class="uk-text-bold uk-text-center">Download File</h2>
        <div class="uk-text-center" uk-grid v-if="data.length > 0">
          <div
            class="uk-width-1-4@m uk-width-1-2 uk-margin-bottom"
            v-for="(item, index) in data"
            :key="index"
          >
            <div class="uk-card uk-card-default card-download" @click="openDetail(item)">
              <div class="uk-card-media-top">
                <img :src="item.image" width="1800" height="1200" alt="" />
              </div>
              <div class="uk-card-body uk-text-left uk-text-bold" style="padding: 10px 15px;">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="uk-text-center" v-else>No result!</div>
      </div>
    </div>
    <div v-else class="uk-section" style="height: 70vh">
      <div class="uk-container" style="height: 100%">
        <div class="uk-flex uk-flex-center uk-flex-middle" style="height: 100%">
          <div uk-spinner></div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";

export default {
  name: "download",
  components: {
    NavigationBar,
    Footer,
  },
  data() {
    return {
      data: [],
      loading: true,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.data = [];
      axios.get(`${process.env.VUE_APP_API_ROOMI_URL}files`).then((res) => {
        this.loading = false;
        if (res.status == 200) {
          const data = res.data;
          if (data.success) {
            this.data = data.data;
          }
        }
      });
    },
    openDetail(item) {
      this.$router.push(`/download/${item.seo_url}`)
    }
  },
};
</script>

<style scoped>
ul.app-desc {
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  line-height: 1;
  width: 50%;
}

ul.app-desc li {
  padding: 2.5px 0;
  text-transform: capitalize;
  color: rgb(164, 173, 184);
  word-spacing: 2px;
  font-weight: 300;
  letter-spacing: 1.5px;
}

ul.app-desc li::after {
  content: "|";
  margin-left: 5px;
  margin-right: 5px;
}

ul.app-desc li:last-child::after {
  content: "";
}

/* ul.uk-slider-items li img {
	height: 200px;
} */

.card-download {
  cursor: pointer;
}

.card-download:hover {
  box-shadow: 0 5px 15px rgb(0 0 0 / 25%) !important;
}

@media screen and (max-width: 639px) {
  .text-container > * {
    text-align: center;
  }

  ul.app-desc {
    margin: auto;
    display: inline-block;
    width: 100%;
  }

  ul.app-desc li a {
    text-align: center;
  }

  ul.app-desc li::after {
    content: "";
  }
}
</style>